import { FaChartBar, FaCode, FaRegNewspaper } from "react-icons/fa";
import { Link } from "react-router-dom";
import useCan from "../../Hooks/useCan";

const ManagementMenu = () => {
    const canSee = useCan({ rolesCan: [] });

    return (
        <div className='container mt-5'>
            <div className='row'>
                <div className='col-lg-4'>
                    <Link to="/managementMenu/news">
                        <div className='card'>
                            <div className='card-body pt-5 pb-5 d-flex align-itens-center justify-content-center'>
                                <FaRegNewspaper size={100} />
                            </div>
                            <div className='card-footer text-muted d-flex align-itens-center justify-content-center'>
                                <span className='text-bold'>Gestão de Notícias</span>
                            </div>
                        </div>
                    </Link>
                </div>
                {canSee &&
                    <div className='col-lg-4'>
                        <Link to="/managementMenu/logs">
                            <div className='card'>
                                <div className='card-body pt-5 pb-5 d-flex align-itens-center justify-content-center'>
                                    <FaChartBar size={100} />
                                </div>
                                <div className='card-footer text-muted d-flex align-itens-center justify-content-center'>
                                    <span className='text-bold'>Extração de Logs</span>
                                </div>
                            </div>
                        </Link>
                    </div>
                }
                {canSee &&
                    <div className='col-lg-4'>
                        <Link to="/financialLines">
                            <div className='card'>
                                <div className='card-body pt-5 pb-5 d-flex align-itens-center justify-content-center'>
                                    <FaCode size={100} />
                                </div>
                                <div className='card-footer text-muted d-flex align-itens-center justify-content-center'>
                                    <span className='text-bold'>Linhas de Financiamento</span>
                                </div>
                            </div>
                        </Link>
                    </div>
                }
            </div>
        </div>
    )
}

export default ManagementMenu;